import { FC } from 'react';

import { SlicesMIR } from '@/shared/graphics/medicalImageRender/MedicalImageRender';
import { useAppDispatch, useAppSelector } from '@/shared/hooks';

import { ModalID, modalModel } from '@/entities/modal';
import { reportsModel } from '@/entities/reports';

import { selectors } from '../../model';
import { MedicalImage } from '../MedicalImage';

import styles from './SelectedUploadedMedicalImages.module.scss';

type SelectedUploadedMedicalImagesProps = {
  toothID: string;
  canRemove?: boolean;
  className?: string;
  isReadOnly?: boolean;
  showOrder?: boolean;
  onImageReady?: (assetID: string) => void;
};

export const SelectedUploadedMedicalImages: FC<
  SelectedUploadedMedicalImagesProps
> = (props) => {
  const {
    toothID,
    canRemove,
    className,
    isReadOnly,
    showOrder = true,
    onImageReady,
  } = props;

  const dispatch = useAppDispatch();
  const medicalImages = useAppSelector(
    selectors.selectSelectedUploadedMedicalImages(toothID),
  );

  const openImage = (assetID: string) => {
    dispatch(
      modalModel.actions.openModal({
        modalID: ModalID.MIRenderModal,
        data: { assetID, toothID },
      }),
    );
  };

  return (
    <SlicesMIR
      className={styles.container}
      toothID={toothID}
      onClick={isReadOnly ? undefined : openImage}
    >
      {medicalImages.map((medicalImage) => (
        <MedicalImage
          key={medicalImage.assetID}
          className={className}
          medicalImage={medicalImage}
          order={showOrder ? medicalImage.order : undefined}
          isImgSelected
          onImageReady={onImageReady}
          onRemoveMedicalImage={
            canRemove
              ? () => {
                  void dispatch(
                    reportsModel.thunks.removeToothDisplaySlice({
                      AssetID: medicalImage.assetID,
                      ToothID: toothID,
                    }),
                  );
                }
              : undefined
          }
        />
      ))}
    </SlicesMIR>
  );
};
